const childConcern = [

    {
    label:"Nature of concern:",
    controlType:"text area",
    options:[]
    },
    






]

export default childConcern